export default __webpack_public_path__ + "static/media/authentication-icon.9647340a.svg";